
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lip",
      function () {
        return require("private-next-pages/lip.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lip"])
      });
    }
  